import styled from "styled-components";

export const ButtonWrapper = styled.div`
	display: flex;
	justify-content: space-evenly;
`;
export const Wrapper = styled.div`
	.current-step-label {
		color: #8c8c8c;
		font-size: 12px;
	}
`;
